<a [routerLink]="link" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="sidebar-item u-mx-4 u-mb-24">
    <mat-icon class="sidebar-item--icon u-mx-4 u-px-8" fontSet="material-icons-outlined"> {{ icon }} </mat-icon>
    <span class="sidebar-item--label" *ngIf="opened">
        <ng-content></ng-content>
    </span>
</a>
